"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignAndPersistCustomerId = exports.placeOrder = exports.deleteItem = exports.updateItem = exports.getCart = exports.updateCart = exports.createCart = exports.assignCustomerToOrder = exports.createGenericOrder = exports.createOrder = void 0;
const config_1 = require("../../utils/helpers/config");
const customer_1 = require("../../utils/helpers/customer");
const utils_1 = require("../utils");
class OrderError extends Error {
    constructor(message) {
        super(message);
        this.name = 'OrderError';
    }
}
class CustomerRegisterError extends Error {
    constructor(message) {
        super(message);
        this.name = 'CustomerRegisterError';
    }
}
const createOrder = (params) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient
        .post('/cart/createAndPlaceOrder', params)
        .then((response) => response.data)
        .catch((error) => {
        window.NREUM.noticeError(new OrderError(`Error on integration order`), {
            origin: 'MLD/Checkout',
            brand: config_1.envConfig.currentBrand,
            params: {
                catalogSlug: params.catalogSlug,
                cycle: params.cycle,
            },
        });
        throw error;
    });
});
exports.createOrder = createOrder;
const createGenericOrder = (params) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient
        .post('/cart/generic/order', params)
        .then((response) => response.data);
});
exports.createGenericOrder = createGenericOrder;
const assignCustomerToOrder = (params) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient
        .post('/customer/register', params)
        .then((response) => response.data)
        .catch((error) => {
        window.NREUM.noticeError(new CustomerRegisterError(`Error on register order`), {
            origin: 'MLD/CustomerRegister',
            brand: config_1.envConfig.currentBrand,
            params: {
                customerId: params.customerId,
                orderBackofficeId: params.orderBackofficeId,
            },
        });
        throw error;
    });
});
exports.assignCustomerToOrder = assignCustomerToOrder;
const createCart = (params) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient.post('/cart', params).then((response) => response.data);
});
exports.createCart = createCart;
const updateCart = (cartId, params) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient
        .patch(`/cart/${cartId}`, params)
        .then((response) => response.data);
});
exports.updateCart = updateCart;
const getCart = (cartId) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient.get(`/cart/${cartId}`).then((response) => response.data);
});
exports.getCart = getCart;
const updateItem = (cartId, sku, params) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient
        .put(`/cart/${cartId}/items/${sku}`, params)
        .then((response) => response.data);
});
exports.updateItem = updateItem;
const deleteItem = (cartId, sku) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient
        .delete(`/cart/${cartId}/item/${sku}`)
        .then((response) => response.data);
});
exports.deleteItem = deleteItem;
const placeOrder = (cartId) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.checkoutApiClient
        .post(`/cart/${cartId}/placeOrder`)
        .then((response) => response.data);
});
exports.placeOrder = placeOrder;
const assignAndPersistCustomerId = (orderBackofficeId, recognizedCustomerToken) => __awaiter(void 0, void 0, void 0, function* () {
    const customerIdFromCookies = (0, customer_1.getCustomerId)();
    if (!customerIdFromCookies && !recognizedCustomerToken) {
        return;
    }
    let payload = customerIdFromCookies
        ? { customerId: customerIdFromCookies }
        : { token: recognizedCustomerToken };
    const customerId = yield (0, exports.assignCustomerToOrder)(Object.assign({ orderBackofficeId }, payload)).then((data) => data.customerId);
    if (!customerIdFromCookies) {
        (0, customer_1.saveCustomerId)(customerId);
    }
    return customerId;
});
exports.assignAndPersistCustomerId = assignAndPersistCustomerId;
